import { useQuery } from "@tanstack/react-query";
import { financialsService } from "financials/services";
import { useBoundStore } from "store";

export const financialsKeys = {
  all: ["financials"] as const,
  info: (tenantId?: string, organizationId?: string) =>
    [...financialsKeys.all, "tenant", tenantId ?? "unknown", "organization", organizationId ?? "unknown", "info"] as const,
};

/**
 * Fetches financials info for an organization.
 */
export function useFinancialsInfo(
  organizationId?: string,
  options?: { enabled?: boolean }
) {
  const { tenant } = useBoundStore();

  return useQuery({
    queryKey: financialsKeys.info(tenant?.id, organizationId),
    queryFn: () => financialsService.getFinancialsInfo(tenant!.id, organizationId as string),
    enabled: !!tenant?.id && !!organizationId && (options?.enabled ?? true),
    staleTime: 5 * 60_000,
    ...options,
  });
}
